import { Texto } from '@gravitate-js/excalibrr'
import { isDefined } from '@utils/general'
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'

import { FilterOptionButtons } from '../components/FilterOptionButtons'
import type { FilterOption, TimeDeadline } from '../types'
import { checkIsAmShift, filterByDeadline } from '../util'

const noFitOptionsAM: FilterOption<TimeDeadline>[] = [
  { text: 'Now', value: 'now' },
  { text: 'AM Shift Today', value: 'am today' },
  { text: 'PM Shift Today', value: 'pm today' },
]

const noFitOptionsPM: FilterOption<TimeDeadline>[] = [
  { text: 'Now', value: 'now' },
  { text: 'PM Shift Today', value: 'pm today' },
  { text: 'AM Shift Tomorrow', value: 'am today' },
]

const runoutOptions: FilterOption<TimeDeadline>[] = [
  { text: 'End of Today', value: 'today' },
  { text: 'End of Tomorrow', value: 'tomorrow' },
  { text: '4 Hours', value: 4 },
  { text: '8 Hours', value: 8 },
  { text: '12 Hours', value: 12 },
  { text: '18 Hours', value: 18 },
  { text: '24 Hours', value: 24 },
  { text: '48 Hours', value: 48 },
  { text: '72 Hours', value: 72 },
  { text: 'Next 7 Days', value: 7 * 24 },
]

export const DispatchWindowFilter = forwardRef((props, ref) => {
  const [selectedNoFitIndex, setSelectedNoFitIndex] = useState<number>()
  const [selectedRunoutIndex, setSelectedRunoutIndex] = useState<number>()
  const noFitOptions = checkIsAmShift() ? noFitOptionsAM : noFitOptionsPM

  useEffect(() => {
    props.filterChangedCallback()
  }, [selectedNoFitIndex, selectedRunoutIndex])

  useImperativeHandle(ref, () => {
    return {
      doesFilterPass,
      isFilterActive,
    }
  })

  function doesFilterPass(params) {
    const isCarrierOrder = params.data?.carrier || params.data?.manager
    if (params.data.type?.toLowerCase() === 'backhaul' && !isCarrierOrder) return false

    const start = params.data?.carrier_window_start || params.data?.dispatch_window_start
    const end = params.data?.carrier_window_end || params.data?.dispatch_window_end

    const retainPasses = filterByDeadline(start, noFitOptions[selectedNoFitIndex]?.value)
    const runoutPasses = filterByDeadline(end, runoutOptions[selectedRunoutIndex]?.value)
    return retainPasses || runoutPasses
  }

  function isFilterActive() {
    return isDefined(selectedNoFitIndex) || isDefined(selectedRunoutIndex)
  }
  function handleNoFitClick(index: number) {
    if (selectedNoFitIndex === index) {
      setSelectedNoFitIndex(null)
    } else {
      setSelectedNoFitIndex(index)
      setSelectedRunoutIndex(null)
    }
  }

  function handleRunoutClick(index: number) {
    if (selectedRunoutIndex === index) {
      setSelectedRunoutIndex(null)
    } else {
      setSelectedRunoutIndex(index)
      setSelectedNoFitIndex(null)
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'row', backgroundColor: 'white' }}>
      <div>
        <Texto
          category='p1'
          style={{ padding: '12px 16px', fontWeight: 700, fontSize: '14px', backgroundColor: 'var(--gray-100' }}
        >
          START
        </Texto>
        <FilterOptionButtons options={noFitOptions} handleClick={handleNoFitClick} selectedIndex={selectedNoFitIndex} />
      </div>
      <div>
        <Texto
          category='p1'
          style={{ padding: '12px 16px', fontWeight: 700, fontSize: '14px', backgroundColor: 'var(--gray-100' }}
        >
          END
        </Texto>
        <FilterOptionButtons
          options={runoutOptions}
          handleClick={handleRunoutClick}
          selectedIndex={selectedRunoutIndex}
        />
      </div>
    </div>
  )
})
